import styled from 'styled-components';

export const StyledMachineDetailsPanelRobot = styled.div`
  min-height: inherit;
  height: 100%;
  display: flex;
  flex-direction: column;

  .machine-panel-robot__tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;

    .ant-tabs-nav {
      flex: none;
      margin-bottom: ${(props): string => props.theme.spacing.lg};
    }

    .ant-tabs-content-holder {
      flex: 1;
      min-height: 0;
    }

    .ant-tabs-content {
      height: 100%;
    }

    /* Bound only the Schedule tab to the drawer's available height so its calendar
       scrolls internally; other tabs keep the drawer's natural page scroll. */
    #machine-panel-robot-tabs-panel-SCHEDULE {
      height: 100%;
      overflow: auto;
    }

    .ant-tabs-tab.ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${(props): string => props.theme.colors.black};
        ${(props): string => props.theme.fontStyles.redesign.base.strong}
        font-weight: 500;
      }
    }

    .ant-tabs-ink-bar {
      background-color: ${(props): string => props.theme.colors.black};
      height: 4px;
    }
  }
`;
